"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var observer = new MutationObserver(function (mutationsList, observer) {
    var closeButton = document.querySelector(".coveo-facet-modal-close-button");
    var okButton = document.querySelector(".mobile-close-btn");
    var clearAllButton = document.querySelector(".clear-all-btn");
    var coveoClearAllButton = document.querySelector(".coveo-breadcrumb-clear-all.coveo-accessible-button");
    if (closeButton && okButton) {
      console.log("Popup opened - Attaching event to OK button");
      okButton.addEventListener("click", function () {
        console.log("OK button clicked - Closing popup");
        closeButton.click();
      });
      observer.disconnect();
    }
    if (clearAllButton && coveoClearAllButton) {
      console.log("Popup opened - Attaching event to Clear All button button");
      clearAllButton.addEventListener("click", function () {
        console.log("Clear All button clicked - Closing popup");
        coveoClearAllButton.click();
      });
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  var overlay = document.createElement("div");
  overlay.className = "filter-overlay";
  document.body.appendChild(overlay);
  var observer2 = new MutationObserver(function () {
    var popup = document.querySelector(".coveo-facet-dropdown-modal-content");
    var closeButton = document.querySelector(".coveo-facet-modal-close-button");
    if (popup) {
      console.log("Popup opened - Showing overlay");
      overlay.style.display = "block";
      if (closeButton) {
        closeButton.addEventListener("click", function () {
          console.log("Popup closed - Hiding overlay");
          overlay.style.display = "none";
        });
      }
    } else {
      overlay.style.display = "none";
    }
  });
  observer2.observe(document.body, {
    childList: true,
    subtree: true
  });
});